/*
 * @Author: 张天昊
 * @Date: 2024-05-25 16:49:41
 * @LastEditTime: 2024-05-29 16:15:07
 * @LastEditors: 张天昊
 * @Description:
 * @FilePath: /Mobile/src/pages/itineraryUniversal/navigate.js
 */
import router from '@/router/routers';
import store from '@/store';

export function navigateToTouristsView(ids, range) {
  store.dispatch('itineraryUniversal/pickTouristsIntoView', ids);
  router.push({
    name: 'itineraryUniversalDetailTourists',
    params: router.currentRoute.params,
    query: {
      range
    }
  });
}
